"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = void 0;
require("core-js/modules/es.promise.js");
var _CogManager = require("../../utils/CogManager");
var _EventBus = require("../EventBus");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Player extends Phaser.Physics.Arcade.Sprite {
  constructor(scene) {
    const x = 0;
    const y = 0;
    super(scene, x, y, "marty-waist");
    _defineProperty(this, "ghostPlayer", null);
    this.scene = scene;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.init();
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
  init() {
    if (!this.scene.input.keyboard) return;
    this.registerSounds();

    // Handle resizing
    this.scene.scale.once('resize', this.scaleToFit, this);
    this.scene.scale.once('resize', this.positionOnSky, this);
  }
  positionOnSky() {
    var _this$scene$sky, _this$scene$ground, _this$scene$sky2;
    const gravity = 2000 * (((_this$scene$sky = this.scene.sky) === null || _this$scene$sky === void 0 ? void 0 : _this$scene$sky.scaleFactors.height) || 1);
    this.setOrigin(0.5, 1) // Origin at the bottom center of the player
    .setGravityY(gravity).setCollideWorldBounds(false).setBodySize(90, 140).setOffset(35, 20).setVisible(false).setDepth(4);

    // const y = gameHeight - (gameHeight - skyHeight); // Slight offset for alignment
    const y = (((_this$scene$ground = this.scene.ground) === null || _this$scene$ground === void 0 ? void 0 : _this$scene$ground.y) || 0) - 140;
    this.setY(y);
    this.setX(500 * (((_this$scene$sky2 = this.scene.sky) === null || _this$scene$sky2 === void 0 ? void 0 : _this$scene$sky2.scaleFactors.width) || 1));
    this.setVisible(true);
  }
  scaleToFit() {
    var _this$scene$sky3;
    // Use the scale factor from the Sky class to maintain consistency
    const scaleFactor = ((_this$scene$sky3 = this.scene.sky) === null || _this$scene$sky3 === void 0 ? void 0 : _this$scene$sky3.scaleFactors.height) || 1;
    const width = 285;
    const height = 285;

    // Apply the scale factor to the player
    this.setDisplaySize(width * scaleFactor, height * scaleFactor);
    this.setVisible(true);
  }
  getStartTrigger() {
    /* If the player is connected to a cog, use the cog's buttonClick state to determine if the player should jump / start the game */
    /* Otherwise, use the space key to determine if the player should jump / start the game */
    const connectedCog = (0, _CogManager.getConnectedCog)();
    if (connectedCog) {
      return connectedCog.publishedDataAnalyser.cogState.buttonClick === "click";
    } else {
      return false; // remove this line and comment in below if you want to use the space key to jump when not connected to a cog
      // if (!this.scene.cursors) return false;
      // const space = this.scene.cursors.space;
      // if (this.scene.input.keyboard && this.scene.input.keyboard.checkDown(this.scene.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.A), 0)) {
      //   return true;
      // }
      // if (!space) return false;
      // const isSpaceJustDown = Phaser.Input.Keyboard.JustDown(space);
      // // const { space } = this.scene.cursors;
      // // const isSpaceJustDown = Phaser.Input.Keyboard.JustDown(space);
      // return isSpaceJustDown;
    }
  }
  actionDecider(isCogsButtonClickedOrSpaceDown, onFloor) {
    var _this$scene$currently, _this$scene$currently2, _this$scene$currently3;
    if (!isCogsButtonClickedOrSpaceDown) return;
    if (((_this$scene$currently = this.scene.currentlySectedBlock) === null || _this$scene$currently === void 0 ? void 0 : _this$scene$currently.block) === "moveforward") {
      this.moveForward();
    } else if (((_this$scene$currently2 = this.scene.currentlySectedBlock) === null || _this$scene$currently2 === void 0 ? void 0 : _this$scene$currently2.block) === "movebackward") {
      this.moveBackward();
    } else if (((_this$scene$currently3 = this.scene.currentlySectedBlock) === null || _this$scene$currently3 === void 0 ? void 0 : _this$scene$currently3.block) === "jump") {
      this.jump(onFloor);
    }
  }
  async moveBackward() {
    const move = 10;
    for (let i = 0; i < move; i++) {
      this.setX(this.x - 1);
      await new Promise(resolve => setTimeout(resolve, 10));
    }
    _EventBus.EventBus.emit('player-moved-backward', this.getRemainingDistanceToOffScreenPercentage());
  }
  async moveForward() {
    const move = 10;
    for (let i = 0; i < move; i++) {
      this.setX(this.x + 1);
      await new Promise(resolve => setTimeout(resolve, 10));
    }
    _EventBus.EventBus.emit('player-moved-forward', this.getRemainingDistanceToOffScreenPercentage());
  }
  jump(onFloor) {
    if (onFloor) {
      var _this$scene$sky4, _this$jumpSound;
      const jumpVelocity = -1200 * (((_this$scene$sky4 = this.scene.sky) === null || _this$scene$sky4 === void 0 ? void 0 : _this$scene$sky4.scaleFactors.height) || 1);
      this.setVelocityY(jumpVelocity);
      (_this$jumpSound = this.jumpSound) === null || _this$jumpSound === void 0 || _this$jumpSound.play();
      this.setTexture("marty-jump");
      _EventBus.EventBus.emit('player-jumped', this);
    }
  }
  isOffScreen() {
    const bounds = this.getBounds();
    const adjustedGameWidth = this.scene.scale.width;
    const isOffScreen = bounds.right < 0 || bounds.left > adjustedGameWidth;
    return isOffScreen;
  }
  getRemainingDistanceToOffScreenPercentage() {
    try {
      const bounds = this.getBounds();
      const adjustedGameWidth = this.scene.scale.width;
      if (bounds.right < 0 || bounds.left > adjustedGameWidth) {
        return 100; // Player is already off-screen
      }
      let remainingDistance = 0;
      if (bounds.right > adjustedGameWidth) {
        remainingDistance = bounds.right - adjustedGameWidth; // Distance to the right edge
      } else if (bounds.left < 0) {
        remainingDistance = Math.abs(bounds.left); // Distance to the left edge
      }
      const totalWidth = bounds.width;
      const percentage = Math.min(remainingDistance / totalWidth * 100, 100);
      return percentage;
    } catch (error) {
      return 100;
    }
  }
  update() {
    const isCogsButtonClickedOrSpaceDown = this.getStartTrigger();
    if (this.isOffScreen()) {
      _EventBus.EventBus.emit('player-off-screen', this);
    }
    // if (isCogsButtonClickedOrSpaceDown && !this.scene.isGameRunning && !this.scene.isGameOverVisible) {
    //   this.scene.handleGameStart();
    // }

    // if (!this.scene.isGameRunning) {
    //   return;
    // }

    const onFloor = this.body.onFloor();
    if (onFloor) {
      this.setTexture("marty-waist");
    }
    // get currently selected block and decide movement based on that
    this.actionDecider(isCogsButtonClickedOrSpaceDown, onFloor);
    if (this.body && this.body.deltaAbsY() > 1.39) {
      this.anims.stop();
    } else {
      // this.playRunAnimation();
    }
  }
  registerSounds() {
    this.jumpSound = this.scene.sound.add("jump", {
      volume: 0.3
    });
    this.hitSound = this.scene.sound.add("hit", {
      volume: 0.4
    });
  }
  die() {
    var _this$hitSound;
    this.anims.pause();
    this.setTexture("marty-hurt");
    (_this$hitSound = this.hitSound) === null || _this$hitSound === void 0 || _this$hitSound.play();
  }
  createGhostPlayer() {
    var _this$scene$sky5, _this$scene$ground2, _this$scene$sky6;
    if (!this.scene) return;
    const x = this.x;
    const y = this.y;
    this.ghostPlayer = this.scene.physics.add.sprite(x, y, "marty-waist").setAlpha(0.5) // Semi-transparent
    .setDepth(3); // Ensure it appears above other elements

    // Apply scaling and positioning similar to the main player
    const scaleFactor = ((_this$scene$sky5 = this.scene.sky) === null || _this$scene$sky5 === void 0 ? void 0 : _this$scene$sky5.scaleFactors.height) || 1;
    const width = 285;
    const height = 285;
    this.ghostPlayer.setDisplaySize(width * scaleFactor, height * scaleFactor);
    this.ghostPlayer.setOrigin(0.5, 1); // Origin at the bottom center

    const adjustedY = ((_this$scene$ground2 = this.scene.ground) === null || _this$scene$ground2 === void 0 ? void 0 : _this$scene$ground2.y) || 0;
    this.ghostPlayer.setY(adjustedY);
    this.ghostPlayer.setX(500 * (((_this$scene$sky6 = this.scene.sky) === null || _this$scene$sky6 === void 0 ? void 0 : _this$scene$sky6.scaleFactors.width) || 1));
  }
  playGhostAnimation(timeout) {
    setTimeout(() => {
      if (!this.ghostPlayer) {
        this.createGhostPlayer();
      }
      if (!this.ghostPlayer) return;
      const moveDistance = 150; // Distance to move forward
      const jumpHeight = -600; // Jump velocity

      this.scene.tweens.add({
        targets: this.ghostPlayer,
        x: this.ghostPlayer.x + moveDistance,
        duration: 1000,
        onComplete: () => {
          if (this.ghostPlayer) {
            this.scene.physics.world.enable(this.ghostPlayer);
            const ghostBody = this.ghostPlayer.body;
            ghostBody.setGravityY(1000);
            ghostBody.setCollideWorldBounds(true); // Ensure the ghost stops at the bottom
            ghostBody.onWorldBounds = true; // Enable world bounds collision

            this.ghostPlayer.setVelocityY(jumpHeight);
            this.scene.time.delayedCall(1500, () => {
              var _this$ghostPlayer;
              (_this$ghostPlayer = this.ghostPlayer) === null || _this$ghostPlayer === void 0 || _this$ghostPlayer.destroy();
              this.ghostPlayer = null;
            });
          }
        }
      });
    }, timeout);
  }
}
exports.Player = Player;